import React from 'react';
import Footer from '../Footer/Footer';
import Banner from '../Banner/Banner';
import Contact from '../Contact/Contact';
import Navigation from '../Navigation/Navigation';
import Skills from '../Skills/Skills';
import Projects from '../Projects/Projects';
import About from '../About/About';
import Blogs from '../Blogs/Blogs';

const Home = () => {
    return (
        <div>
            <Navigation></Navigation>
            <Banner></Banner>
            <About></About>
            <Skills></Skills>
            <Projects></Projects>
            <Blogs></Blogs>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default Home;